import React, { useState } from 'react';
import classes from "./storeCheckoutLocatorModal.css";
import { sendGTMEvent } from "../../../util/initGTM";
import { days, getTodayStoreHours } from "../../Header/utils";
import { useStoreSwitcher } from "@magento/peregrine/lib/talons/Header/useStoreSwitcher";
import { useIntl } from 'react-intl';
import Arrow from '@magento/venia-ui/venia-static/icons/chevron.svg';
var ScheduleTimeContainer = props => {
  var {
    fromPage,
    store,
    scheduleStyle = {},
    alwaysOpen = false,
    hasOpener = true
  } = props;
  var [isOpen, setOpen] = useState(alwaysOpen);
  var {
    currentStoreCode
  } = useStoreSwitcher();
  var {
    formatMessage
  } = useIntl();
  var {
    time,
    todayLabel
  } = getTodayStoreHours({
    schedule: store.schedule
  });
  return /*#__PURE__*/React.createElement("div", {
    className: classes.scheduleContainer,
    onClick: () => {
      if (alwaysOpen) {
        return;
      }
      if (!isOpen) {
        switch (fromPage) {
          case 'checkout':
            {
              sendGTMEvent({
                eventCategory: 'checkout step 4.1.1 - select a store',
                eventAction: 'Select Other Store Overlay',
                eventLabel: "".concat(store.name, " - open hours accordion"),
                event: 'genericGAEvent'
              });
              break;
            }
        }
      }
      setOpen(!isOpen);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.scheduleTimeContainer,
    style: scheduleStyle
  }, isOpen ? days.map(day_name => {
    var schedule = store.schedule;
    var {
      time,
      todayLabel
    } = getTodayStoreHours({
      schedule,
      day_name
    });
    var t = '';
    if (todayLabel === day_name) {
      t = 'Today';
    }
    return /*#__PURE__*/React.createElement("div", {
      className: classes["dayTimeRow".concat(t)]
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.todayLabel
    }, formatMessage({
      defaultMessage: day_name,
      id: day_name
    })), /*#__PURE__*/React.createElement("div", null, time));
  }) : /*#__PURE__*/React.createElement("div", {
    className: classes.dayTimeRowToday,
    style: scheduleStyle
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      textTransform: 'capitalize'
    }
  }, formatMessage({
    defaultMessage: todayLabel,
    id: todayLabel
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: 'end'
    }
  }, time))), !alwaysOpen && hasOpener ? /*#__PURE__*/React.createElement("div", {
    className: classes.arrowButton,
    style: {
      transform: isOpen ? 'rotate(180deg)' : 'rotate(0)'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: Arrow,
    alt: "Arrow"
  })) : null);
};
export default ScheduleTimeContainer;